// extracted by mini-css-extract-plugin
export default {"app":"Statistics_app__z0KAL","box":"Statistics_box__JY7Gq","list":"Statistics_list__DmnWF","item":"Statistics_item__hCbKl"};